import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";
import PelagicQuepos from "./pages/tournaments/PelagicQuepos"

class App extends Component {
  render() {
    return (
      <BrowserRouter>
      <div>
        <Route path="/" component={PelagicQuepos} name="Pelagic Rockstar Costa Rica" exact/>
      </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js